module.exports = __webpack_public_path__ + "assets/img/PC5.70014532.jpg";